import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { encrypt } from '@utils/encryption';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import LoadingButton from '@shared/components/LoadingButton';
import LanguageSwitcher from '@layouts/langSwitch/componenets/LanguageSwitcher'; 
import AuthContext from '@providers/context/componenets/AuthContext';
const PUBLIC_KEY = import.meta.env.VITE_PUBLIC_KEY;

const Login = () => {
    const { loginSubmitHandler, errorMessage } = useContext(AuthContext);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const validationSchema = yup.object({
        username: yup.string()
            .required(t('login.requiredUser'))
            .min(1, t('login.userMinLength'))
            .max(30, t('login.userMaxLength')),
        password: yup.string()
            .required(t('login.requiredPassword'))
            .min(1, t('login.passwordMinLength'))
            .max(60, t('login.passwordMaxLength'))
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onChange'
    });

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            const encryptedPassword = encrypt(data.password,PUBLIC_KEY);
            
            const loginData = {
                username: data.username,
                password: encryptedPassword
            };

            await loginSubmitHandler(loginData);
        } catch (error) {
            console.error('Login error:', error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className='login-wrapper'>
            <div className="login-form-container">
                <LanguageSwitcher />
                <h3>Sofis - HR & Payroll</h3>
                <hr/>
                <img 
                    src="/images/logo/bulmagMiddle.png" 
                    alt="Logo" 
                    className="login-company-logo"
                    height="30"
                />
                <form className='form' onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                        <label htmlFor="dropdown">{t('login.chooseDomain')} </label>
                        <select 
                            id="dropdown" 
                            {...register('dropdown')}
                        >
                            <option value="">{t('login.choose')}</option>
                            <option value="option1">Опция 1</option>
                            <option value="option2">Опция 2</option>
                            <option value="option3">Опция 3</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="username">{t('login.username')}</label>
                        <input
                            type="text"
                            {...register('username')}
                            id="username"
                            className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                        />
                        {errors.username && <div className="invalid-feedback">{errors.username.message}</div>}
                        {errorMessage && <div className="error-message">{errorMessage}</div>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">{t('login.password')}</label>
                        <input
                            type="password"
                            {...register('password')}
                            id="password"
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                        />
                        {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
                    </div>
                    <LoadingButton 
                        type="submit"
                        className='login-btn'
                        loading={loading}
                    >
                        {t('login.login')}
                    </LoadingButton>
                </form>
            </div>
        </div>
    );
};

export default Login;